/**
 * Created by raul on 10/15/14.
 */
module media.hrratings.events {
    export class ApplicationEvent {
        static STARTUP          : string = "ApplicationStartup";
        static STARTUP_COMPLETE : string = "ApplicationStartup_COMPLETE";
        static LOADER_COMPLETE  : string = "ApplicationLOADER_COMPLETE";
    }
}